import { render, staticRenderFns } from "./PortalDocumentosInterno.vue?vue&type=template&id=dda49c6c"
import script from "./PortalDocumentosInterno.vue?vue&type=script&lang=js"
export * from "./PortalDocumentosInterno.vue?vue&type=script&lang=js"
import style0 from "./PortalDocumentosInterno.vue?vue&type=style&index=0&id=dda49c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports